import React from 'react';

const MARKDOWN_TOKEN_REGEX = /(\*\*[^*\n]+\*\*|`[^`\n]+`)/g;

export function renderFormattedText(text: string): React.ReactNode {
  if (!text) return null;

  const parts = text.split(MARKDOWN_TOKEN_REGEX);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length >= 4) {
      return (
        <strong key={index} className="font-semibold text-slate-900">
          {part.slice(2, -2)}
        </strong>
      );
    }
    if (part.startsWith('`') && part.endsWith('`') && part.length >= 2) {
      return (
        <code key={index} className="px-1 py-0.5 bg-slate-100 rounded text-[11px] font-mono text-slate-800">
          {part.slice(1, -1)}
        </code>
      );
    }
    return part;
  });
}
